module.exports = __webpack_public_path__ + "img/skirt waist.bcb7b142.png";